module.exports = __webpack_public_path__ + "static/media/mobile_archero2_page_area02_img_en@2x.ef8442ce.png";